



































import { ECustomerGroup, ExportType, SalesOrgDto } from '@/services/connecteur'
import SalesOrgsModule from '@/store/modules/SalesOrgsModule'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import SalesOrgImportStatusDialog from './SalesOrgImportStatus/SalesOrgImportStatusDialog.vue'

@Component({
  components: {
    SalesOrgImportStatusDialog
  }
})
export default class SalesOrgTab extends Vue {
  public ECustomerGroup = ECustomerGroup
  public ExportType = ExportType

  public headers: any[] = [
    { text: this.$t('salesOrg.description'), value: 'description' },
    { text: this.$t('salesOrg.fileCode'), value: 'fileCode' },
    { text: this.$t('salesOrg.compagnyCode'), value: 'compagnyCode' },
    { text: this.$t('salesOrg.sapCode'), value: 'sapCode' },
    { text: this.$t('salesOrg.docType'), value: 'docType' },
    // { text: this.$t('salesOrg.deliveryBlock'), value: 'deliveryBlock' },
    // { text: this.$t('salesOrg.orderReason'), value: 'orderReason' },
    { text: this.$t('salesOrg.fixQuotationType'), value: 'fixQuotationType' },
    { text: this.$t('salesOrg.lvlCustomer'), value: 'lvlCustomer' },
    { text: this.$t('salesOrg.isMatureForSAP'), value: 'isMatureForSAP' },
    { text: this.$t('salesOrg.offsetAPO'), value: 'offsetAPO' },
    { text: this.$t('salesOrg.exportType'), value: 'exportType' },
    { text: this.$t('salesOrg.importStatus'), value: 'salesOrgImports' },
    { text: this.$t('snpMapping.actions'), align: 'center', value: 'actions' }
  ]

  @Prop({ default: '' })
  public search !: string

  @Prop({ default: false })
  public showDisabled !: boolean

  public get salesOrg (): SalesOrgDto[] {
    return this.showDisabled ? SalesOrgsModule.salesOrgs : SalesOrgsModule.salesOrgsWithoutDisabled
  }

  public async mounted () {
    await SalesOrgsModule.loadAllSalesOrg()
    SalesOrgsModule.updateSelectedSalesOrg()
  }

  public updateOrDeleteSalesOrg (value: SalesOrgDto, event: string) {
    SalesOrgsModule.updateSelectedSalesOrg(value)

    this.$emit(event)
  }
}
